import {
  GAME_ID,
  REDUX_ACTIONS,
} from '../../data/constants';

const initialState = {
  // id of current level
  currentLevelId: null,
  // max set id for current level
  // every level has 6*n questions, so e.g. if it has 18, it will have setIds0,1,2 maxSetId will be 2
  maxSetId: null,
  // id of current set in current level
  currentSetId: null,
  lastPlayedSetsByLevel: {},
};

const curriculumReducer = (state = initialState, action) => {
  if (action.gameId !== GAME_ID) {
    return state;
  }

  switch (action.type) {
    case REDUX_ACTIONS.INIT_ROUND: {
      const { levelId, maxSetId, currentSetId } = action.payload;

      return {
        ...state,
        currentLevelId: levelId,
        currentSetId,
        maxSetId,
      };
    }

    case REDUX_ACTIONS.COMPLETE_CURRENT_SET_ID: {
      return {
        ...state,
        lastPlayedSetsByLevel: {
          ...state.lastPlayedSetsByLevel,
          [state.currentLevelId]: state.currentSetId,
        },
      };
    }
    case REDUX_ACTIONS.INIT_CURRICULUM: {
      return {
        ...initialState,
      };
    }
    default:
      return state;
  }
};

export default curriculumReducer;
